import React from 'react';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

// DndProvider is missing children in Props
const DndProviderAsAny: any = DndProvider;

function withDragDropContext<P extends Object, S> (WrappedComponent: React.ComponentClass<P, S>) {
  return (props: P) => (
    <DndProviderAsAny backend={HTML5Backend}>
      <WrappedComponent {...props} />
    </DndProviderAsAny>
  );
}

export {
  withDragDropContext
};

export default withDragDropContext;